<div class="vincent_about2">
    <div class="row">
        <div class="col col-12 vincent_content">

            <div class="row vincent_reservation" style="flex-direction: row-reverse;">
                <div class="col col-6 vincent_reservation_block_black ">
                    <div class="rel-top">
                        <h1>لوحة التحكم</h1>
                        <img src="assets/imgs/separator_light.png">
                        <p class="bitch-p">القرن مع إصدار رقائق القرن مع إصدار رقائق القرن مع إصدار رقائق</p>
                        <div class="vincent_form_block ">
                            <a class="vincent_button" routerLink="/menus-panel">الدخول</a>
                        </div>
                    </div>
                </div>
                <div class="col col-6 vincent_reservation_block">
                    <div class="rel-top">
                        <h1>عرض الطلبات</h1>
                        <img src="assets/imgs/separator_dark.png">
                        <p class="bitch-p">القرن مع إصدار رقائق القرن مع إصدار رقائق القرن مع إصدار رقائق</p>
                        <div class="vincent_form_block ">
                            <a class="vincent_button" routerLink="/op-instructions">الدخول</a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>